// src/Logger.js

export const LOG_LEVELS = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
  PERF: 4
};

class Logger {
  constructor(minLevel = LOG_LEVELS.INFO) {
    this.minLevel = minLevel;
  }

  debug(msg, data = '') { this._log(LOG_LEVELS.DEBUG, 'DEBUG', msg, data, '#8b5cf6'); }
  info(msg, data = '') { this._log(LOG_LEVELS.INFO, 'INFO', msg, data, '#10b981'); }
  warn(msg, data = '') { this._log(LOG_LEVELS.WARN, 'WARN', msg, data, '#f59e0b'); }
  error(msg, data = '') { this._log(LOG_LEVELS.ERROR, 'ERROR', msg, data, '#ef4444'); }
  
  perf(label, fn) {
    const start = performance.now();
    const result = fn();
    const end = performance.now();
    this._log(LOG_LEVELS.PERF, 'PERF', `${label}: ${(end - start).toFixed(2)}ms`, '', '#3b82f6');
    return result;
  }

  _log(level, label, msg, data, color) {
    if (level < this.minLevel) return;
    const timestamp = new Date().toLocaleTimeString();
    console.log(
      `%c[${timestamp}] [${label}] %c${msg}`,
      `color: ${color}; font-weight: bold;`,
      'color: inherit;',
      data
    );
  }
}

export const logger = new Logger();
